import {AfterViewInit, Component, Input} from '@angular/core';
import {KpiReport} from '../../../../models/measure/report';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';

@Component({
  selector: 'exposure-kpi-report',
  templateUrl: './exposure-kpi-report.component.html',
  styleUrls: ['./exposure-kpi-report.component.scss']
})
export class ExposureKpiReportComponent implements AfterViewInit {
  static COMPONENT_NAME = 'ExposureKpiReportComponent';
  @Input()
  kpiReports: KpiReport[];

  constructor(private pdfService: PdfExportService) {

  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(ExposureKpiReportComponent.COMPONENT_NAME);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/measure/exposure-kpi-report/exposure-kpi-report.component.ts